let AdobeAn;
let exportRoot;
import createjs from 'createjs';
/* eslint-disable camelcase */
(function(cjs, an) {
    let p; // shortcut to reference prototypes
    const lib = {};
    const ss = {};
    const img = {};
    lib.ssMetadata = [];

    // symbols:
    // helper functions:

    function mc_symbol_clone() {
        const clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
    }

    function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        const prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
    }

    (lib.Symbol2 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#FFFFFF')
            .s()
            .p('AhkATICFhMIBEAmIiFBNg');
        this.shape.setTransform(60.8, 8.5);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#E7E7E7')
            .s()
            .p('AhCgmICFhOIAACbIiFBOg');
        this.shape_1.setTransform(64.1, 18.2);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#B9C4E3')
            .s()
            .p('AghA6IAAiaIBDAnIAACag');
        this.shape_2.setTransform(54, 20.1);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .f('#FFFFFF')
            .s()
            .p('AmrAAIGrj2IGsD2ImsD3g');
        this.shape_3.setTransform(39.3, -49.4);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .f('#B9C4E3')
            .s()
            .p('AjVFyIAAvbIGrD4IAAPbg');
        this.shape_4.setTransform(17.9, 12.4);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics
            .f('#9AA5C0')
            .s()
            .p('AjVlxIGrj4IAAPbImrD4g');
        this.shape_5.setTransform(60.7, 12.4);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics
            .f('#FFFFFF')
            .s()
            .p('AoFjdICHhOIOEIJIiHBOg');
        this.shape_6.setTransform(-30.2, -44.2);

        this.shape_7 = new cjs.Shape();
        this.shape_7.graphics
            .f('#9AA5C0')
            .s()
            .p('AhCgmICFhOIAACbIiFBOg');
        this.shape_7.setTransform(14.8, -10.3);

        this.shape_8 = new cjs.Shape();
        this.shape_8.graphics
            .f('#E7E7E7')
            .s()
            .p('AnCi2IAAibIOFIIIAACbg');
        this.shape_8.setTransform(-37, -32.5);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({
                    state: [
                        {t: this.shape_8},
                        {t: this.shape_7},
                        {t: this.shape_6},
                        {t: this.shape_5},
                        {t: this.shape_4},
                        {t: this.shape_3},
                        {t: this.shape_2},
                        {t: this.shape_1},
                        {t: this.shape}
                    ]
                })
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol2, new cjs.Rectangle(-82, -74.1, 164.1, 148.3), null);

    (lib.Symbol1 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#9AA5C0')
            .s()
            .p('AmrCfINXnuIAACyItXHtg');
        this.shape.setTransform(42.8, 24.7);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#B9C4E3')
            .s()
            .p('AmridIAAiyINXHuIAACxg');
        this.shape_1.setTransform(-42.8, 24.7);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#E7E7E7')
            .s()
            .p('AtXAAINXntINYHtItYHvg');
        this.shape_2.setTransform(0, -8.8);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol1, new cjs.Rectangle(-85.6, -58.3, 171.3, 116.6), null);

    // stage content:
    (lib._3 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Symbol 2
        this.instance = new lib.Symbol2();
        this.instance.parent = this;
        this.instance.setTransform(0.2, 57.3, 1, 1, 0, 0, 0, -81.9, -61.1);

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .to({regX: -81.8, regY: -61, x: 0.3, y: 13.2}, 23, cjs.Ease.quadInOut)
                .to({regX: -81.9, regY: -61.1, x: 0.2, y: 57.3}, 3, cjs.Ease.get(1))
                .wait(5)
        );

        // Symbol 1
        this.instance_1 = new lib.Symbol1();
        this.instance_1.parent = this;
        this.instance_1.setTransform(121.1, 176.7);

        this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(31));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(104, 162.8, 206.7, 190.8);
    // library properties:
    lib.properties = {
        id: '553B767DC9474D1C99F2D4313B625737',
        width: 208,
        height: 237,
        fps: 24,
        color: '#CCCCCC',
        opacity: 0.0,
        manifest: [],
        preloads: []
    };

    // bootstrap callback support:

    (lib.Stage = function(canvas) {
        createjs.Stage.call(this, canvas);
    }).prototype = p = new createjs.Stage();

    p.setAutoPlay = function(autoPlay) {
        this.tickEnabled = autoPlay;
    };
    p.play = function() {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
    };
    p.stop = function(ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
    };
    p.seek = function(ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
    };
    p.getDuration = function() {
        return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
    };

    p.getTimelinePosition = function() {
        return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
    };

    an.bootcompsLoaded = an.bootcompsLoaded || [];
    if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
    }

    an.bootstrapCallback = function(fnCallback) {
        an.bootstrapListeners.push(fnCallback);
        if (an.bootcompsLoaded.length > 0) {
            for (let i = 0; i < an.bootcompsLoaded.length; ++i) {
                fnCallback(an.bootcompsLoaded[i]);
            }
        }
    };

    an.compositions = an.compositions || {};
    an.compositions['553B767DC9474D1C99F2D4313B625737'] = {
        getStage: function() {
            return exportRoot.getStage();
        },
        getLibrary: function() {
            return lib;
        },
        getSpriteSheet: function() {
            return ss;
        },
        getImages: function() {
            return img;
        }
    };

    an.compositionLoaded = function(id) {
        an.bootcompsLoaded.push(id);
        for (let j = 0; j < an.bootstrapListeners.length; j++) {
            an.bootstrapListeners[j](id);
        }
    };

    an.getComposition = function(id) {
        return an.compositions[id];
    };
})((createjs = createjs || {}), (AdobeAn = AdobeAn || {}));

const composition = AdobeAn.getComposition('553B767DC9474D1C99F2D4313B625737');

export {AdobeAn};
export {composition};
